import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import {Theme} from '@mui/material';

import {
    portalLoginLogoHeightSelector,
    portalLoginLogoSelector
} from '../../store/selectors';

import {NewPasswordForm} from '../../components/login';
import FooterLinksSection from "../../components/common/FooterLinksSection";
import {respondNewPasswordChallenge} from "../../store/actions";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    grow: {
        flexGrow: 1,
        minHeight: theme.spacing(2)
    },
    content: {
        width: '100%',
        maxWidth: '388px',
        padding: `0 ${theme.spacing(2)}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box'
    },
    error: {
        marginBottom: theme.spacing(3)
    },
    logo: {
        marginBottom: theme.spacing(6)
    }
}));

const NewPasswordPage = (): React.ReactElement => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const logo = useSelector(portalLoginLogoSelector);
    const logoHeight = useSelector(portalLoginLogoHeightSelector);

    const onChangePassword = useCallback(
        ({newPassword, confirmPassword}: { newPassword: string; confirmPassword: string }) => {
            dispatch(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                respondNewPasswordChallenge({
                    newPassword
                })
            );
        },
        []
    );

    return (
        <div className={classes.container}>
            <div className={classes.grow}/>
            <div className={classes.content}>
                <img
                    className={classes.logo}
                    alt="troy"
                    src={logo}
                    height={logoHeight}
                />
            </div>
            <div className={classes.grow}/>
            <NewPasswordForm onSubmit={onChangePassword}/>
            <FooterLinksSection/>
        </div>
    );
};

export default NewPasswordPage;
